import React from 'react';
import { useSiteContext } from '../../context/SiteContext';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  const { data } = useSiteContext();

  const linksByCategory = data.footerLinks
    ?.filter(l => l.active)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .reduce((acc, link) => {
      if (!acc[link.category]) acc[link.category] = [];
      acc[link.category].push(link);
      return acc;
    }, {});

  return (
    <footer className="bg-[#0a0a0e] border-t border-white/10 pt-16 pb-8">
      <div className="w-full max-w-[1440px] 2xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                <SafeIcon name="Layers" className="text-white w-4 h-4" />
              </div>
              <span className="font-bold text-xl tracking-tight text-white">
                BPA Solutions
              </span>
            </div>
            <p className="text-slate-400 max-w-sm mb-6">
              Building practical website systems that connect front-end presentation with back-end business efficiency.
            </p>
            <a
              href="mailto:hello@bpasolutions.au"
              className="text-blue-400 hover:text-blue-300 font-medium inline-flex items-center gap-2 group transition-colors"
            >
              <SafeIcon name="Mail" className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
              hello@bpasolutions.au
            </a>
          </div>
          {linksByCategory &&
            Object.entries(linksByCategory).map(([category, links]) => (
              <div key={category}>
                <h4 className="text-white font-semibold mb-6">{category}</h4>
                <ul className="space-y-4">
                  {links.map((link, idx) => (
                    <li key={idx}>
                      <a
                        href={link.url}
                        className="text-slate-400 hover:text-white text-sm transition-colors duration-300 inline-flex items-center gap-1.5 group"
                      >
                        <span className="w-0 overflow-hidden group-hover:w-2 transition-all duration-300 opacity-0 group-hover:opacity-100 text-blue-500">
                          ›
                        </span>
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} BPA Solutions. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span>Built beyond the page.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;